import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private hubConnection: signalR.HubConnection;

  constructor(
    private notificationService:NotificationService
  ) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.appConfig.notificationServiceBaseUrl}/notificationHub`)
      .build();

  }

  public startConnection(userId:string) {
    this.hubConnection
      .start()
      .then(() =>{
        
         console.log('SignalR connection started');
         this.addListeners(userId);

      }
        )
      .catch(err => console.log('Error while starting SignalR connection:'));
  }

  private addListeners(userId:string) {
    this.hubConnection.on('ReceiveNotification', (messageStr) => {
      let message=JSON.parse(messageStr);
      // this.notificationService.pushNotificationItems.unshift({id:message.Id,createdAt:message.CreatedAt,
      //   description:message.DescriptionEn,descriptionEn:message.DescriptionEn,
      //   descriptionAr:message.DescriptionAr,isRead:false,title:message.titleEn});
      // this.notificationService.unreadPushNotificationsCount++;
      //this.notificationService.info(message.DescriptionEn)
      console.log('Message received from server:', message);
    });
    this.hubConnection?.invoke('JoinGroup', userId)
    .catch((err:any) => {
      //this.notificationService.error('Error while joining group:');
    });
  }
 
  public stopConnection() {
    this.hubConnection
      .stop()
      .then(() => console.log('SignalR connection stopped'))
      .catch(err => console.log(err));
  }
}